import {IClient} from '../common/types';

export const createClientStateFromResponse = (response: any): IClient => ({
  firstName: response.firstname || 'NaN',
  secondName: response.lastname || 'NaN',
  middleName: response.fathername || 'NaN',
  birthday: response.dt || 'NaN',
  age: response.age || 'NaN',
  gender: replaceGenderShortToLongLabel(response.sex) || 'NaN',
  phoneNumber: response.phone || 'NaN',
  accessKey: response.access_key || 'NaN',
});


const replaceGenderShortToLongLabel = (shortLabel: string) => {
  if (shortLabel === 'M') return 'Чоловіча';
  if (shortLabel === 'F') return 'Жіноча';

  return 'Не вказано';
};